import { useEffect, useState } from 'react';
import { getVendors } from 'business/services/IngredientService';

const useVendorsList = (showVendorModal, refetchCounter = 0) => {
  const [vendorsList, setVendorsList] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const vendorList = await getVendors();
      setVendorsList(vendorList);
    };
    if (showVendorModal) {
      fetchData();
    }
  }, [showVendorModal, refetchCounter]);

  return vendorsList;
};

export default useVendorsList;
